// Copyright (c) 2016 Deere & Company

import {
    getElementOffsetHeight,
    getElementOffsetTop,
    getWindowHeight,
    resizeReportGrid,
    scrollWindowXTo
} from './window-helpers';

export const uiSpacing = 18;

export const scrollToAndResizeReport = () => {

    const pageHeaderHeight = getElementOffsetHeight('app-header');

    const reportHeaderTop = getElementOffsetTop('help-text');

    const reportGridTop = getElementOffsetTop('report-grid');

    const windowHeight = getWindowHeight();

    scrollWindowXTo(reportHeaderTop - pageHeaderHeight - uiSpacing);

    resizeReportGrid(windowHeight - pageHeaderHeight - uiSpacing + reportHeaderTop - reportGridTop - uiSpacing);

};



// WEBPACK FOOTER //
// ./src/reports/shared/services/scroll-window.js